export const SIGN_UP_PROCESS_CONFIG = [
  {
    number: 1,
    title: 'Create your free account',
    description: 'Get started with Pata pet care booking software in minutes. No credit card required.',
  },
  {
    number: 2,
    title: 'Add your services and availability',
    description:
      'Set up your grooming, walking, training or sitting services, assign team members and set your availability.',
  },
  {
    number: 3,
    title: 'Turn on online bookings',
    description:
      'Allow clients to book and pay online and reduce cancellations with upfront payments and automated reminders.',
  },
  {
    number: 4,
    title: 'Grow your visibility and bookings',
    description:
      'Share your Pata profile link and appear on the Pata Marketplace to attract more pet owners looking for your services.',
  },
];
